module.exports = " <div class=send_panel _v-41edec91=\"\"> <toolbar _v-41edec91=\"\"></toolbar> <input-area _v-41edec91=\"\"></input-area> <action-bar _v-41edec91=\"\"></action-bar> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-41edec91!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/body/session/SendPanel.vue
 ** module id = 343
 ** module chunks = 2
 **/